import { UserTypeEnum, type UserWithGroupsType } from "@validereinc/domain";
import { isValidereInternalUserEmail } from "../users/index.ts";

export const getNumberOfUsersThatCanAccessQuicksightConsole = (
  users: UserWithGroupsType[]
) =>
  users
    .filter(
      (user) =>
        user.type === UserTypeEnum.human && user.can_access_quicksight_console
    )
    .filter((user) => user.email && !isValidereInternalUserEmail(user.email))
    .length ?? 0;
